import React, { useEffect, useState } from 'react';
import { fetchDriverImage } from '../../../../../Dispatch/utils/utils';
import DriverImage from '../../../../../Dispatch/RouteExecution/Drivers/DriverInfoPopup/components/DriverImage';
import Message from '../../../../../Dispatch/RouteExecution/Drivers/DriverInfoPopup/components/Message';
import { getDriverStatus } from '../../../../../Dispatch/RouteExecution/utils/DriverStatus';

const DriverInfo = ({ driverData, classes, terminalCode, onMessageHistoryClick, route }) => {
  const [driverImage, setDriversImage] = useState(null);
  const setDriverImage = async (driverNumber) => {
    if (!driverNumber) {
      return;
    }
    if (!driverImage) {
      const driverImage = (await fetchDriverImage([driverNumber], terminalCode))[0]?.driverImage;
      setDriversImage(driverImage);
    }
  };

  useEffect(() => {
    setDriverImage(driverData.driverNumber);
  }, []);

  return (
    <div className={classes.rowContainer}>
      <DriverImage
        driverImage={driverImage}
        customStyle={{
          driverImg: classes.driverImg,
          imgStyle: classes.imgStyle
        }}
      />
      <div>
        <div className={classes.driverNameContainer}>
          <div className={classes.driverName}>{driverData.driverName || ""}</div>
          <Message onClick={onMessageHistoryClick} tooltipMessage="View message history" />
        </div>
        <div className={classes.headerText}>
          {driverData?.driverNumber ? `#${driverData?.driverNumber}` : ''}
        </div>
        {route.isLiveDispatch && (
          <div className={classes.statusValue}>{getDriverStatus({ data: route })}</div>
        )}
      </div>
    </div>
  );
};

export default DriverInfo;
